import { apiClient } from '../client'

/**
 * Security API endpoints (devices, login attempts, etc.)
 */
export const securityApi = {
  /**
   * Get logged in devices
   */
  getDevices: async (): Promise<any> => {
    const { data } = await apiClient.get('/auth/devices/')
    return data
  },

  /**
   * Revoke device
   */
  revokeDevice: async (deviceId: string): Promise<void> => {
    await apiClient.delete(`/auth/devices/${deviceId}/`)
  },

  /**
   * Get login attempts
   */
  getLoginAttempts: async (): Promise<any> => {
    const { data } = await apiClient.get('/auth/login-attempts/')
    return data
  },

  /**
   * Change password
   */
  changePassword: async (payload: { old_password: string; new_password: string }): Promise<any> => {
    const { data } = await apiClient.post('/auth/change-password/', payload)
    return data
  },

  /**
   * Revoke all devices except current
   */
  revokeAllDevices: async (): Promise<any> => {
    const { data } = await apiClient.post('/auth/devices/revoke-all/')
    return data
  },
}
